export class ParametroAwsSesModel {
  id?: number;
  grupoId?: number;
  accessKeyId?: string;
  secretAccessKey?: string;
  region?: string;
  emailRemetente?: string;
  limiteMsg?: number;
  limiteMsgsMinutos?: number;
  valorUnitarioMsg?: number;
  moedaCusto: 'BRL' | 'USD' | 'EUR' = 'USD';
  usuario?: string;
  senha?: string;
  ativo?: boolean;
  dataCriacao?: string;
  dataAlteracao?: string;
}
